// extracted by mini-css-extract-plugin
export default {"center":"ScoopCenter_center__pcltK"};